import { useAppInsights } from "@/shared/utils/logger/app-insights";

const { trackEvent, trackException, trackMetric } = useAppInsights();

/**
 * Log event to console and app insights
 * @param codename Short event name string (code name of event)
 * @param properties Custom data to log
 */
export const logEvent = (codename: string, properties: Record<string, any> = {}) => {
    console.log(codename, properties);
    trackEvent(codename, properties);
};

/**
 * Log exception to console and app insights.
 * @param codename  Short exception name string (code name of event)
 * @param exception Object from the exception (try..catch value)
 * @param properties Custom data to log
 * @param noConsole Log exception without logging to console (default: false)
 */
export const logException = (
    codename: string,
    exception: Error | unknown,
    properties: Record<string, any> = {},
    noConsole: boolean = false,
) => {
    if (!noConsole) console.error(codename, exception, properties);
    trackException(exception as Error, { codename: codename, ...properties });
};

/**
 * Log custom exception to console and app insights.
 * @param codename  Short exception name string (code name of event)
 * @param message Short message of error
 * @param properties Custom data to log
 */
export const logCustomException = (codename: string, message: string, properties: Record<string, any> = {}) => {
    const error = new Error(message);
    logException(codename, error, properties);
};

/**
 * Log some metric to app insights
 */
export const logMetric = trackMetric;
